import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";
import { LIFE_INSURANCE_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/LifeInsuranceForm/lifeInsuranceFormDefaults";
import type { LifeInsuranceFormInput } from "web_myplann/Portfolio/Forms/LifeInsuranceForm/lifeInsuranceFormSchema";

export const mapPortfolioToLifeInsuranceForm = (
	portfolio: PortfolioDetailResponseDTO,
): LifeInsuranceFormInput => {
	return {
		name: portfolio.name ?? DEFAULTS.name,
		contractNumber: portfolio.contractNumber ?? DEFAULTS.contractNumber,
		producer: portfolio.producer ?? DEFAULTS.producer,
		product: portfolio.product ?? DEFAULTS.product,
		signedAt: parseIsoDate(portfolio.signedAt),
		startAt: parseIsoDate(portfolio.startAt),
		endAt: parseIsoDate(portfolio.endAt),
	};
};
